import { render, staticRenderFns } from "./AppIframe.vue?vue&type=template&id=d5f82448&"
import script from "./AppIframe.vue?vue&type=script&lang=js&"
export * from "./AppIframe.vue?vue&type=script&lang=js&"
import style0 from "./AppIframe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports